import { render, staticRenderFns } from "./sendContacts.vue?vue&type=template&id=4bc16c88"
import script from "./sendContacts.vue?vue&type=script&lang=js"
export * from "./sendContacts.vue?vue&type=script&lang=js"
import style0 from "./sendContacts.vue?vue&type=style&index=0&id=4bc16c88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports